import DomainDetails from './DomainDetails'
import IpAddressDetails from './IpAddressDetails'
import UrlDetails from './URLDetails'
import { HashSummary } from '@horizon-shared/hash-details'

export const detailsMap = {
  fqdn: DomainDetails,
  md5: HashSummary,
  sha1: HashSummary,
  sha256: HashSummary,
  ipv4: IpAddressDetails,
  url: UrlDetails,
}
